import {updateCart} from '@@/js/components/cart';

class QuantityInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const input = this.querySelector('input');
    const minus = this.querySelector('button:first-of-type');
    const plus = this.querySelector('button:last-of-type');
    const cart = this.closest('.woocommerce-cart-form');

    if (input) {
      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || Infinity;

      const updateButtonState = () => {
        if (input.value <= min) {
          minus.classList.add('is-disabled');
        } else {
          minus.classList.remove('is-disabled');
        }

        if (input.value >= max) {
          plus.classList.add('is-disabled');
        } else {
          plus.classList.remove('is-disabled');
        }

      };

      minus.addEventListener('click', () => {
        if (input.value > min) {
          input.value = parseInt(input.value) - 1;
          updateButtonState();
          cart && updateCart();
        }
      });

      plus.addEventListener('click', () => {
        if (input.value < max) {
          input.value = parseInt(input.value) + 1;
          updateButtonState();
          cart && updateCart();
        }
      });

      // Initial state update
      updateButtonState();
    }
  }

  disconnectedCallback() {
  }
}

customElements.define('quantity-input', QuantityInput);

